import styled from 'styled-components';
import { darken } from 'polished';
import { Heading, Section } from 'components';
import { color, font, media } from 'style';

const CircleButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  background: transparent;
  outline: none;
  border-radius: 50%;
  box-shadow: 0 0 5px 1px rgba(0, 0, 0, 0.1);
  color: ${color.hmBrandPurple};
  background-color: white;
  text-align: center;
  -webkit-tap-highlight-color: transparent;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:hover {
    color: ${darken(0.05, color.hmBrandPurple)};
    background-color: ${darken(0.03, 'white')};
  }

  &:active {
    box-shadow: none;
  }
`;

export default {
  Section: styled(Section)`
    overflow: hidden;
  `,
  Title: styled(Heading)`
    text-align: center;
    margin-bottom: 50px;
  `,
  CarouselWrapper: styled.div`
    position: relative;
    width: 100%;
    overflow: hidden;

    .slick-slide,
    .slick-slide * {
      outline: none !important;
    }
    .slick-track {
      display: flex;
      align-items: center;
    }
  `,
  ButtonsWrapper: styled.div`
    position: absolute;
    max-width: 800px;
    width: 100%;
    height: 100%;
    left: 50%;
    transform: translateX(-50%);
    z-index: 3;
    pointer-events: none;
  `,
  CircleButtonLeft: styled(CircleButton)`
    transform: scaleX(-1);
    position: absolute;
    left: 10px;
    top: 50%;
    pointer-events: auto;
  `,
  CircleButtonRight: styled(CircleButton)`
    position: absolute;
    right: 10px;
    top: 50%;
    pointer-events: auto;
  `,
  TestimonialCardWrapper: styled.div`
    box-sizing: border-box;
  `,
  TestimonialCard: styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 215px;
    max-width: 620px;
    padding: 20px 40px;
    margin: 15px auto;
    text-align: center;
    box-shadow: 0px 5px 15px 5px rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    box-sizing: border-box;

    ${media.sm`
    padding: 20px 35px;
  `};
  `,
  TestimonialContainer: styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  `,
  Quote: styled.img`
    display: none !important;
    width: 30px;

    ${media.sm`
    display: block !important;
  `};
  `,
  Testimonial: styled.div`
    font-weight: ${font.weight.light};
    font-style: italic;

    ${media.sm`
    margin: 0 10px;
  `};
  `,
  Name: styled(Heading)`
    font-weight: ${font.weight.bold};
    font-size: 17px;
  `,
};
